<template>
<div id="download">
      
      <div class="container">
        <div class="row">
          <h2>Baixe agora nas lojas de aplicativos</h2>
        </div>
        <div class="row justify-content-between">
          <div class="col-md-12 buttons">
            <a href="https://appsto.re/br/1NETdb.i"><img :src="appStore"/></a>
            <a href="https://play.google.com/store/apps/details?id=click2giv.app"><img :src="playStore"/></a>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import appStore from '../../assets/images/app-store.png';
import playStore from '../../assets/images/play-store.png';

export default {
  data(){
    return {
      appStore: appStore,
      playStore: playStore
    }
  }
}
</script>

<style scoped lang="scss">
#download{
  background-color: #00AE39;
  padding: 40px;

  h2{
    display: block;
    font-size: 28px;
    color: #fff;
    text-align: center;
    width: 100%;
    font-family: RalewayRegular;
  }

  .buttons{
    text-align: center;
    margin-top: 10px;
    @media screen and(max-width: 494px){
      a{
        margin-top: 10px;
        display: block;
      }
    }
  }

  img{
    width: 190px;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/home/DownloadSection.vue